import React from "react";
import "../../GlobalCss/SPF/CanadaMfTable.css";
// import "./CanadaMfTable.css"
import { useState, useEffect } from "react";
import { Form, Input, Popconfirm, Table, Typography, Button, Modal, Spin, Image, DatePicker } from 'antd';
import {
    SendOutlined, EditOutlined, CheckOutlined, CloseOutlined, ReloadOutlined, DownOutlined, ExclamationCircleOutlined,
    SearchOutlined
} from "@ant-design/icons";
// import { getPayrollData, refreshPayrollData, updateMFRow } from "../../Repository/TenNinetyNineRepository";
import { ErrorMessage, SuccessMessage, InfoMessage } from "../../Utils/Utils";
import { BaseUrl, JsonConfig, jwtToken } from "../../Repository/BaseRepository";
import axios from "axios";
import { updateCanadaMFRow, getCanadaPayrollData, downloadCanadaMSXL } from "../../Repository/CanadaPayrollRepository";
const { RangePicker } = DatePicker;

const CanadaMfTable = ({ tableLoader, griddata, setGriddata, setTableLoader, fromDate, setFromDate, toDate, setTodate }) => {

    const originalData = griddata;
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const [rowData, setRowData] = useState([]);
    const [searchRow, setSearchRow] = useState("")
    const [filteredData, setFilteredData] = useState(griddata);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [syncSpin, setSyncSpin] = useState(false)
    const [newFrom, setNewFrom] = useState("")
    const [newTo, setNewTo] = useState("")
    const isEditing = (record) => record.id === editingKey;
    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
    const filterProps = () => ({
        filteredValue: [searchRow],
        onFilter: (value, record) => {
            return (
                String(record.Client)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.Client_Type)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.Payroll_Name).toLowerCase().includes(value.toLowerCase())
            );
        },
    });

    const columns = [
        {
            title: 'PORTAL',
            key: 'Client_Type',
            dataIndex: 'Client_Type',
            editable: true,
            width: 150,
            ...filterProps(),
        },
        {
            title: 'CLIENT',
            key: 'Client',
            dataIndex: 'Client',
            width: 200,
            editable: true,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'PAYROLL NAME',
            key: 'Payroll_Name',
            dataIndex: 'Payroll_Name',
            editable: true,
            width: 220,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'TIMECARD STATUS',
            key: 'Status',
            dataIndex: 'Status',
            editable: true,
            width: 190,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'RT',
            key: 'RT',
            dataIndex: 'RT',
            editable: true,
            width: 80
        },
        {
            title: 'OT',
            key: 'OT',
            dataIndex: 'OT',
            editable: true,
            width: 80
        },
        {
            title: 'DT',
            key: 'DT',
            dataIndex: 'DT',
            editable: true,
            width: 80
        },
        {
            title: 'OTHER HOURS',
            key: 'Other_Hours',
            dataIndex: 'Other_Hours',
            editable: true,
            width: 120
        },
        {
            title: 'WEEK START DATE',
            key: 'WeekStartDate',
            dataIndex: 'WeekStartDate',
            editable: true,
            width: 170
        },
        {
            title: 'WEEK END DATE',
            key: 'Weekend',
            dataIndex: 'Weekend',
            editable: true,
            width: 170
        },
        // {
        //     title: 'DOCUMENT DATE',
        //     key: 'Invoice_Date',
        //     dataIndex: 'Invoice_Date',
        //     editable: true,
        //     width: 180
        // },
        // {
        //     title: 'TOTAL HOURS',
        //     key: 'Total_Hours',
        //     dataIndex: 'Total_Hours',
        //     editable: true,
        //     width: 180
        // },
        // {
        //     title: 'INVOICE NUMBER',
        //     key: 'Invoice_Number',
        //     dataIndex: 'Invoice_Number',
        //     editable: true,
        //     width: 180,
        //     ellipsis: true,
        //     render: (text, record, index) => (
        //         <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
        //     )
        // },
        // {
        //     title: 'INVOICE AMOUNT',
        //     key: 'Invoice_Amount',
        //     dataIndex: 'Invoice_Amount',
        //     editable: true,
        //     width: 180
        // },
        // {
        //     title: 'DUE DATE',
        //     key: 'Due_Date',
        //     dataIndex: 'Due_Date',
        //     editable: true,
        //     width: 180
        // },
        // {
        //     title: 'PAY RATE',
        //     key: 'Pay_rate',
        //     dataIndex: 'Pay_rate',
        //     editable: true,
        //     width: 180
        // },
        // {
        //     title: 'COMMENTS',
        //     key: 'Comments',
        //     dataIndex: 'Comments',
        //     editable: true,
        //     width: 180
        // },
        {
            title: 'DOWNLOAD DATE',
            key: 'DownloadDate',
            dataIndex: 'DownloadDate',
            // editable: true,
            width: 180
        },
        {
            title: 'ACTION',
            dataIndex: 'action',
            fixed: 'right',
            width: 100,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Popconfirm title="Sure to save?" onConfirm={() => editTableRowData(record)}
                            onCancel={cancel}>
                            <Typography.Link
                                style={{
                                    marginRight: 8,
                                }}
                            >
                                <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
                            </Typography.Link>
                        </Popconfirm>
                        <Typography.Link onClick={() => cancel()}>
                            <CloseOutlined style={{ color: "red" }} />
                        </Typography.Link>

                    </span>
                ) : (
                    <div>
                        <Typography.Link onClick={() => edit(record)} disabled={editingKey !== ''} >
                            <Image
                                src="/Images/editicon.svg"
                                style={{
                                    border: "none",
                                    width: "100% ",
                                    marginRight: 5
                                }}
                                showPreviewIcon={false}
                                preview={false}
                            />
                        </Typography.Link>
                        {/* <Popconfirm
                            title="Are you sure want to delete?"
                            onConfirm={() => deleteGridRow(record)}
                            okText="Yes"
                            cancelText="No">
                            <Typography.Link>
                                <Image
                                    src="./Images/deleteicon.svg"
                                    style={{
                                        border: "none",
                                        width: "100% ",
                                        marginLeft: 5
                                    }}
                                    showPreviewIcon={false}
                                    preview={false}
                                />
                            </Typography.Link>
                        </Popconfirm> */}
                    </div>

                );
            },
        },
    ]
    const edit = (record) => {
        setRowData(record)
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.id);
        // console.log(rec)
    }
    const compareObjects = (obj1, obj2) => {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length || !keys1.every(key => keys2.includes(key))) {
            return false;
        }
        for (const key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }
        return true;
    };
    const compareLists = (rowData, currentRowData) => {
        if (typeof rowData !== 'object' || typeof currentRowData !== 'object') {
            return false;
        }
        const result = compareObjects(rowData, currentRowData);
        return result;
    };
    function formatDateToYYYYMMDD(date) {
        if (date !== null) {
            if (date !== "") {
                const [month, day, year] = date.split('/');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            }
        }
        else {
            return null;
        }
    }
    const editTableRowData = async (props) => {
        try {
            const currentRowData = await form.getFieldValue();
            const comparision = compareLists(rowData, currentRowData);
            if (comparision === false) {
                const tempWeekend = formatDateToYYYYMMDD(currentRowData.Weekend)
                const tempWeekStart = formatDateToYYYYMMDD(currentRowData.WeekStartDate)
                const data = {
                    "id": currentRowData.id,
                    "client_Type": currentRowData.Client_Type,
                    "client": currentRowData.Client,
                    "payroll_Name": currentRowData.Payroll_Name,
                    "weekend": tempWeekend,
                    "rt": currentRowData.RT,
                    "ot": currentRowData.OT,
                    "dt": currentRowData.DT,
                    "status": currentRowData.Status,
                    "other_Hours": currentRowData.Other_Hours,
                    "WeekStartDate": tempWeekStart,
                    "userName": currentRowData.UserName,
                    "invoice_Date": currentRowData.Invoice_Date,
                    "invoice_Hrs": currentRowData.Invoice_Hrs,
                    "invoice_Number": currentRowData.Invoice_Number,
                }
                const updateresponse = await updateCanadaMFRow(data)
                if (updateresponse.data.statusCode === 200) {
                    const res = await getCanadaPayrollData(newFrom, newTo)
                    if (res !== null && res.length > 0) {
                        setGriddata(res)
                    }
                    SuccessMessage(updateresponse.data.message)
                }
                else if (updateresponse.data.statusCode === 500) {
                    InfoMessage(updateresponse.data.message)
                }
                else {
                    ErrorMessage("Cannot able to update, please try again")
                }
                setEditingKey("");
            }
            else {
                InfoMessage("No changes made. Edit and try again.")
            }
        }
        catch (err) {
            return err
        }
    }
    const cancel = () => {
        setEditingKey("");
    }
    const deleteGridRow = (record) => {
        setEditingKey("");
    }
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const refreshDataMethod = async () => {
        try {
            setSyncSpin(true)
            setTableLoader(true)
            const res = await refreshPayrollData();
            if (res !== null && res.length > 0) {
                setGriddata(res)
            }
            setSyncSpin(false)
            setTableLoader(false)
        }
        catch {
            setSyncSpin(false)
            setTableLoader(false)
        }
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const downloadMSfile = async () => {
        try {
            // setCsvLoader(true)
            const resp = await downloadCanadaMSXL(griddata)
            if (resp === "downloaded") {
                SuccessMessage("Downloaded successfully !!")
            }
            // setCsvLoader(false)
        }
        catch {
            ErrorMessage("Cannot able to download, please try again")
            // setCsvLoader(false)
        }
    }
    const changeFromDate = (e) => {
        let sample = new Date(e)
        if (e !== null) {
            setFromDate(sample)
        }
        else {
            setFromDate()
        }
        var newD = parseInt(sample.getMonth() + 1) + '/' + parseInt(sample.getDate())+ '/' + parseInt(sample.getFullYear());
        setNewFrom(newD)
        if (toDate !== undefined && sample < toDate && e !== null) {
            console.log("call api")
            callConsolidatedApi(newD, newTo)
        }
        else if (toDate !== undefined && sample > toDate && e !== null) {
            InfoMessage("From date should not be greater than To date")
        }
    }
    const changeToDate = (e) => {
        let sample = new Date(e)
        if (e !== null) {
            setTodate(sample)
        }
        else {
            setTodate()
        }
        var newD = parseInt(sample.getMonth() + 1) + '/' + parseInt(sample.getDate())+ '/' + parseInt(sample.getFullYear());
        setNewTo(newD)
        if (fromDate !== undefined && fromDate < sample && e !== null) {
            console.log("call api to date")
            callConsolidatedApi(newFrom, newD)
        }
        else if (fromDate !== undefined && fromDate > sample && e !== null) {
            InfoMessage("To date should be greater than From date")
        }
    }
    const callConsolidatedApi = async(from, to) => {
        try {
            setTableLoader(true)
            const res = await getCanadaPayrollData(from, to);
            console.log(res)
            if (res !== null && res.length > 0) {
                setGriddata(res);
            }
            setTableLoader(false)
        }
        catch {
            ErrorMessage("Cannot able to get data, please try again")
        }
    }

    return (<>
        <div className="mfrow-canada">
            <Input
                placeholder="Search Portal \ Client \ Payroll Name"
                className="MFten-searchrow"
                style={{ width: "40%" }}
                onChange={(e) => setSearchRow(e.target.value)}
                allowClear
                suffix={
                    <SearchOutlined
                        style={{ color: "#7185FF", justifyContent: "space-between" }}
                    />
                }
            />
            <div >
                <DatePicker className="msf-datepickers" onChange={changeFromDate} placeholder="From Date" format={"MM-DD-YYYY"} />
                <DatePicker className="msf-datepickers" onChange={changeToDate} placeholder="To Date" format={"MM-DD-YYYY"} />
            </div>
            <div style={{ display: "flex", alignItems: "center", paddingRight: 10 }}>
                <Button onClick={downloadMSfile} className="dwld-invoice">Consolidated Data</Button>
            </div>
            {/* {syncSpin ?
                <Spin indicator={<ReloadOutlined style={{ fontSize: 18, marginLeft: 10, color: "#3B52DF" }} spin />} /> :
                <Tooltip title={
                    <span
                        className="placeholder-span"
                        style={{ color: "#ffff" }}
                    >
                        Refresh data
                    </span>
                } color={"#108ee9"} key={"#108ee9"}>
                    <ReloadOutlined style={{ fontSize: 18, marginLeft: 10, color: "#3B52DF", cursor: "pointer" }}
                        onClick={refreshDataMethod} />
                </Tooltip>} */}
        </div>
        <div className={griddata.length > 0 ? "ten99-table-class" : "ten99-empty-table"} style={{ marginTop: 40 }}>
            {
                tableLoader ?
                    <Spin tip="Loading...">
                        <Form form={form} component={false}>
                            <Table
                                className="ten99-table"
                                rowClassName="editable-row"
                                columns={mergedColumns}
                                dataSource={originalData.map(item => ({ ...item, key: item.id }))}
                                components={{ body: { cell: EditableCell, }, }}
                                bordered
                                // rowSelection={rowSelection}
                                scroll={{ x: 1500, y: 400 }}
                            // pagination
                            /> </Form> </Spin> :
                    griddata.length > 0 ? < Form form={form} component={false} >
                        <Table
                            className="ten99-table"
                            rowClassName="editable-row"
                            columns={mergedColumns}
                            dataSource={originalData.map(item => ({ ...item, key: item.id }))}
                            components={{ body: { cell: EditableCell, }, }}
                            bordered
                            // rowSelection={rowSelection}
                            scroll={{ x: 1500, y: 400 }}
                        />
                    </Form> : < Form form={form} component={false} >
                        <Table
                            className="ten99-table"
                            rowClassName="editable-row"
                            columns={mergedColumns}
                            dataSource={originalData.map(item => ({ ...item, key: item.id }))}
                            components={{ body: { cell: EditableCell, }, }}
                            bordered
                            // rowSelection={rowSelection}
                            scroll={{ x: 400, y: 400 }}
                        />
                    </Form>
            }
        </div>
        {/* <div className="crawl-prepare-row">
            <Button className="crawl-prepare-button">Crawl & Prepare</Button>
        </div> */}
    </>)
}
export default CanadaMfTable;